import { Injectable } from '@angular/core';

import {CusHttp} from '../../core/services/CusHttp';
// 定义接口  
// 热门岗位关键字列表

const HOTWORLDURL = 'v1/position-keyword/list';

@Injectable()
export class AddrInputService {

  constructor(
    public _http:CusHttp,
  ) { }
  //热门岗位关键字列表
  getHotKeyWorld(){
    return this._http.get(HOTWORLDURL);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/addr-input/addr-input.service.ts